import "./styles/tailwind.css";
import './styles/index.css'

import * as Sentry from '@sentry/browser'
import React from 'react'
import ReactDOM from 'react-dom'
import AuthorizedApolloProvider from './apolloClient'
import App from './App'
import { Auth0Provider } from './contexts/Auth0Context'
import { config } from './contexts/service'
import * as serviceWorker from './serviceWorker'

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: process.env.REACT_APP_SENTRY_DSN,
})

ReactDOM.render(
  <Auth0Provider {...config}>
    <AuthorizedApolloProvider>
      <App />
    </AuthorizedApolloProvider>
  </Auth0Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
